import { BaseIcon } from './BaseIcon';
import { DealsIcon } from 'foundations-assets/icons/components/DealsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const DealsSvg = () => {
  return /*#__PURE__*/_jsx(BaseIcon, {
    children: /*#__PURE__*/_jsx(DealsIcon, {})
  });
};